import axios from "axios";
import authHeader from "./auth-header";

//const API_URL = "http://localhost:8080/api/test/";
const API_URL = "https://atletismo-be.customdevsolution.com/api/test/";

const getPublicContent = () => {
  return axios.get(API_URL + "all");
};

///////////////////////////
{/**
return axios
.post(API_URL + "signin", {
  username,
  password,
})
.then((response) => {
  if (response.data.accessToken) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }
  return response.data;
})
.catch(() => {
  console.log(response.data);
  localStorage.setItem("user", JSON.stringify(response.data));
  return response.data;
});
 */}

{/**
const getUserBoard = () => {
  // accessToken: "no" causes Login to be rendered...
  // but when Login is rendered, it checks if there is a user on LocalStorage..
  // if there is a user on local storage, then loads WrapperApp.
  const user = {id:1, username: "username", roles: "admin", accessToken: "no"}; 
  
  const response = {data: {
    id: user.id,
    username: user.username,
    email: user.email,
    roles: user.roles,
    accessToken: user.accessToken
  }};

  return axios
  .get(API_URL + "user", { headers: authHeader() })
  .then((response) => {
    if (response.data.accessToken) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }
    return response;
  })
  .catch(() => {
    //console.log(response.data);
    localStorage.setItem("user", JSON.stringify(response.data));
    return response;
  });  
};
*/} 

const getUserBoard = () => {
  return axios.get(API_URL + "user", { headers: authHeader() });
};

const getModeratorBoard = () => {
  return axios.get(API_URL + "mod", { headers: authHeader() });
};

const getAdminBoard = () => {
  return axios.get(API_URL + "admin", { headers: authHeader() });
};

export default {
  getPublicContent,
  getUserBoard,
  getModeratorBoard,
  getAdminBoard
}
